import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const cache = new Map();

/**
 * usePlatformSetting — fetch a single platform_settings row by key.
 * Cached in-memory; safe for public reads.
 */
export default function usePlatformSetting(key, fallback = null) {
  const [value, setValue] = useState(cache.get(key) ?? fallback);
  const [loading, setLoading] = useState(!cache.has(key));

  useEffect(() => {
    if (cache.has(key)) {
      setValue(cache.get(key));
      setLoading(false);
      return;
    }
    let active = true;
    supabase
      .from("platform_settings")
      .select("value")
      .eq("key", key)
      .maybeSingle()
      .then(({ data }) => {
        if (!active) return;
        const v = data?.value ?? fallback;
        cache.set(key, v);
        setValue(v);
        setLoading(false);
      });
    return () => { active = false; };
  }, [key]);

  return { value, loading };
}